"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["open", "handleClose", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxShadow: theme.customShadows["default"],
      borderRadius: 5
    },
    backdrop: {
      backgroundColor: (0, _styles.fade)(theme.palette.background.backdrop, 0.6)
    }
  };
});
var Modal = function Modal(_ref) {
  var open = _ref.open,
    handleClose = _ref.handleClose,
    children = _ref.children,
    other = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    className: classes.root,
    onClose: handleClose,
    open: open,
    BackdropProps: {
      className: classes.backdrop
    }
  }, other), children);
};
Modal.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired,
  handleClose: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Modal;